/*=========================================================================================
  File Name: mutations.js
  Description: Hub Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Hub Module
  Author: Tan Tran
==========================================================================================*/

export default {
    SET_HUB_CONNECTION_STATE (state, payload) {
        state.isConnected = payload.isConnected;
    }
}